var _path, _path2, _path3, _text, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoNa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "absolute inset-0 w-full h-full drop-shadow-lg",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 65L50 85L75 65L50 45L25 65Z",
    fill: "url(#cubeGradient1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45L75 65L75 35L50 15L50 45Z",
    fill: "url(#cubeGradient2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 65L50 45L50 15L25 35L25 65Z",
    fill: "url(#cubeGradient3)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 60,
    fontFamily: "Arial",
    fontSize: 28,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "white"
  }, "\n                                        NA\n                                    ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cubeGradient1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0284c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cubeGradient2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0284c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1e3a8a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cubeGradient3",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1e40af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0369a1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNa);
export default __webpack_public_path__ + "static/media/logoNA.984c3b8b8be300b3030d0f643ad5b18a.svg";
export { ForwardRef as ReactComponent };